import {
  useAppPersistenceStore,
  useEventZStore,
  UserProps,
  useWeatherStore,
} from '@ninjacart/nc-nk-store';
import {
  ChangeLanguageBottomSheet,
  Container,
  KisanLogoNew,
  UIBottomSheet,
  useTheme,
  View,
  XStack,
  YStack,
} from '@ninjacart/nc-nk-ui';
import { useEffect, useState } from 'react';
import { GlobalSearch } from './globalSearch';
import { HeaderActions } from './headerActions';
import { useHeaderEvents } from './hooks/useHeaderEvents';
import { useLanguageChange } from './hooks/useLanguageChange';
import { WeatherWidget } from './weatherWidget';

interface HomeHeaderProps {
  isWeatherWidgetAvailable: boolean;
  globalSearchEnabled: boolean;
  headerHeight?: number;
  userProfile?: UserProps;
  headerStyles?: object;
}

export const HomeHeader = ({
  isWeatherWidgetAvailable,
  globalSearchEnabled,
  headerHeight = 128,
  headerStyles,
}: HomeHeaderProps) => {
  const theme = useTheme();
  // console.log("🚀 ~HomeHeader  theme:", theme)

  // Custom hooks for business logic
  const { handleSearch, handleWeatherPage, handleCreatePost, handleProfileClick, handleLogin } =
    useHeaderEvents();
  const { languageChangeBottomSheet, setLanguageChangeBottomSheet, onLanguageChange } =
    useLanguageChange();

  // State and store hooks
  const weatherActionData = useWeatherStore((state) => state.weatherActionData);
  const enableLanguageIcon = useEventZStore((state) => state.enableLanguageIcon);
  const appLanguage = useAppPersistenceStore((state) => state.appLanguage);
  const profileTabLanguageFilter = useEventZStore((state) => state.profileTabLanguageFilter);
  const enableWeatherWidget = weatherActionData?.temp_min && isWeatherWidgetAvailable;
  const [weather, setWeather] = useState(false);

  useEffect(() => {
    if (enableWeatherWidget) {
      setWeather(true);
    }
  }, [enableWeatherWidget]);

  return (
    <Container flex={1} maxHeight={headerHeight} backgroundColor={'$homeStatusBarColor'}>
      <View width={'100%'} height={headerHeight}>
        <YStack flex={1} flexDirection="column" justifyContent="flex-start">
          <XStack flex={1}>
            <XStack flex={1} alignItems="center" onPress={handleLogin}>
              <KisanLogoNew width={180} height={48} />
              {weather && (
                <WeatherWidget
                  temperature={weatherActionData.temp_min}
                  onPress={handleWeatherPage}
                />
              )}
            </XStack>

            <HeaderActions
              enableLanguageIcon={enableLanguageIcon}
              appLanguage={appLanguage}
              profileTabLanguageFilter={profileTabLanguageFilter}
              onLanguageChange={() => setLanguageChangeBottomSheet(true)}
              onProfileClick={handleProfileClick}
              onCreatePost={handleCreatePost}
              theme={theme}
            />
          </XStack>

          <XStack flex={1} height={36} flexDirection="row">
            <GlobalSearch onSearch={handleSearch} />
          </XStack>
        </YStack>

        {languageChangeBottomSheet && (
          <UIBottomSheet
            open={languageChangeBottomSheet}
            animation={'quick'}
            snapPoints={[70]}
            onOpenChange={setLanguageChangeBottomSheet}
            children={
              <ChangeLanguageBottomSheet
                setLanguageChangeBottomSheet={setLanguageChangeBottomSheet}
                onLanguageChange={onLanguageChange}
              />
            }
          />
        )}
      </View>
    </Container>
  );
};
